export const PT_GROCERY_PRODUCT =
  "/grocery-product/:frompage/:navigatepage/:category/:pid/:lineid/:adonlineid/:isrecommended";
export const PT_GROCERY_CATEGORY = "/grocery-category";
export const PT_GROCERY_PRODUCT_LIST = "/grocery-product-list/:navPage";

export const GROCERY_STACK_PATHS_CONTAIN_CHECK = (pathname) => {
  let firstPart = pathname.split("/").filter(Boolean)[0];
  let paths =
    PT_GROCERY_CATEGORY + PT_GROCERY_PRODUCT + PT_GROCERY_PRODUCT_LIST;
  let x = paths.toUpperCase().includes(firstPart.toUpperCase());
  return x;
};
